/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.RuleCondition = (function () {

    function RuleCondition (rule, id) {

        this.rootEl = document.createElement('div');
        var entity = rule.entityToAction;
        var fieldContainerClass = 'fieldContainer';

        var renderField = function (field) {
            this.fieldWithValue = new Greenmile.PanelBuilder.Fields.Render(field, entity).render();
            var container = this.rootEl.querySelector('.' + fieldContainerClass);
            container.innerHTML = '';
            container.appendChild(this.fieldWithValue.render());
        }.bind(this);

        this.setValue = function (value) {
            this.value = value;
            this.selectFieldList.setSelectedField(value.entityField);
            this.fieldWithValue.setValue(value);
        };

        this.getValue = function () {
            var value = this.fieldWithValue.getValue();
            delete value.entity;

            return value;

        }.bind(this);

        var deleteRuleCondition = function (e) {
            var container = e.target.parentNode;
            container.parentNode.removeChild(container);

            delete rule.ruleConditions[id];
        }.bind(this);

        var renderRuleCondition = function () {

            var fieldContainer = document.createElement('div');
            this.selectFieldList = new Greenmile.PanelBuilder.Fields.RuleSelectFieldList(entity);

            fieldContainer.className = fieldContainerClass;
            this.selectFieldList.addClickEventListener(renderField);
            this.selectFieldList.render();

            this.rootEl.appendChild(this.selectFieldList.elFieldList);
            this.rootEl.appendChild(fieldContainer);
            var firstField = Greenmile.PanelBuilder.Utils.getFirstField(this.selectFieldList.fieldList);
            this.selectFieldList.setSelectedField(firstField);
            renderField(firstField);
            this.rootEl.appendChild(Greenmile.PanelBuilder.Utils.getBtnDelete(deleteRuleCondition));

        }.bind(this);

        this.render = function () {

            var section2 = document.createElement('div');
            section2.className = 'section2';

            renderRuleCondition();

            return this.rootEl;

        };

    }

    return RuleCondition;

}());
